import { useEffect, useState } from 'react';
import { NAV } from './data';
import { useActiveSection, useScrolled } from './hooks';
import { IconMoon, IconSun } from './Icons';

const IDS = NAV.map((item) => item.id);

export default function Nav({ theme, onToggleTheme }) {
  const scrolled = useScrolled();
  const active = useActiveSection(IDS);
  const [open, setOpen] = useState(false);
  const nextTheme = theme === 'dark' ? 'light' : 'dark';

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    const onResize = () => {
      if (window.innerWidth >= 1180) setOpen(false);
    };
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    window.addEventListener('resize', onResize);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
      window.removeEventListener('resize', onResize);
    };
  }, [open]);

  const links = (className) =>
    NAV.map((item) => (
      <a
        key={item.id}
        href={`#${item.id}`}
        aria-current={active === item.id ? 'true' : undefined}
        className={className}
        onClick={() => setOpen(false)}
      >
        {item.label}
      </a>
    ));

  return (
    <header className={`nav${scrolled ? ' is-scrolled' : ''}${open ? ' is-open' : ''}`}>
      <div className="nav__bar wrap">
        <a className="brand" href="#top" aria-label="Ayush Kumawat, home">
          <span className="brand__mark" aria-hidden="true">
            AK
          </span>
          <span className="brand__name">Ayush Kumawat</span>
        </a>
        <nav className="nav__links" aria-label="Primary">
          {links()}
        </nav>
        <div className="nav__tools">
          <button
            type="button"
            className="iconbtn"
            onClick={onToggleTheme}
            aria-label={`Switch to ${nextTheme} theme`}
          >
            {theme === 'dark' ? <IconSun /> : <IconMoon />}
          </button>
          <button
            type="button"
            className="nav__menu"
            aria-expanded={open}
            aria-controls="site-menu"
            onClick={() => setOpen((value) => !value)}
          >
            {open ? 'Close' : 'Menu'}
          </button>
        </div>
      </div>
      <div id="site-menu" className={`nav__panel${open ? ' is-open' : ''}`} hidden={!open}>
        <nav className="wrap" aria-label="Mobile">
          {links('nav__panel-link')}
        </nav>
      </div>
    </header>
  );
}
